<template>
    <div class="btn-group">
        <li
        :style="{
          '--fontColor2': style.fontColor2,
          '--fontFamily': style.fontFamily
        }"
        @click="toggleMenu()" class="seat-dropdown-toggle" v-if="selectedOption !== undefined">
          <span class="ss--city">{{ initialFlight.from }}</span> <i class="icon-arrow_back icon-arrow-forward"></i> <span class="ss--city">{{ initialFlight.to }}</span>
          <i v-if="flights.length > 1" class="fas fa-angle-down"></i>
        </li>

    <!--     <li @click="toggleMenu()" class="seat-dropdown-toggle" v-if="selectedOption.label === undefined">
          {{placeholderText}}
          <span class="caret"></span>
        </li> -->

        <ul class="seat-dropdown-menu" v-if="showMenu">
            <li v-for="option in options" :key="option.id">
                <a
                :style="{
                  '--fontColor2': style.fontColor2,
                  '--fontFamily': style.fontFamily,
                  '--passengerSelectedColor': style.passengerSelectedColor
                }"
                href="javascript:void(0)" @click="updateOption(option)">
                  {{ option.departure_airport }} <i class="icon-arrow_back icon-arrow-forward"></i> {{ option.arrival_airport }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      selectedOption: null,
      showMenu: false,
      placeholderText: 'Please select an item'
    }
  },
  props: {
    options: {
      type: [Array, Object]
    },
    selected: {},
    placeholder: [String],
    updater: null
  },

  mounted () {
    this.selectedOption = this.selected
    if (this.placeholder) {
      this.placeholderText = this.placeholder
    }
  },

  computed: {
    initialFlight () {
      var _this = this
      var flightLabels = this.options.filter(function (option) {
        return option.id === _this.selectedOption
      })
      if (flightLabels.length === 1) {
        return flightLabels[0]
      }

      return {
        label: '...',
        from: '...',
        to: '...'
      }
    },
    ...mapGetters(['style', 'flights'])
  },

  methods: {
    updateOption (option) {
      this.selectedOption = option.id
      this.showMenu = false
      this.updater(this.selectedOption)
    },

    updateSelectedOption (optionId) {
      this.selectedOption = optionId
      this.showMenu = false
      // this.updater(this.selectedOption)
    },

    toggleMenu () {
      if (this.flights.length > 1) {
        this.showMenu = !this.showMenu
      }
    }
  }
}
</script>
<style>
#ss-container .ss--city {
  margin: 5px;
  white-space: nowrap;
  font-weight: 600;
}
.icon-arrow-forward {
  font-size: 18px;
  transform: rotate(180deg);
  padding: 0 5px;
}
#ss-container .btn-group {
  width: 100%;
  max-width: 220px !important;
  height: 40px;
  position: relative;
  margin: 0px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: flex-start;
}
.btn-group a:hover {
  text-decoration: none;
}
.seat-dropdown-toggle {
  /*color: var(--fontColor2);*/
  width: 100%;
  height: 40px;
  text-transform: none;
  font-family: var(--fontFamily);
  font-size: 18px;
  border: 0;
  border-radius: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  /*justify-content: space-between;*/
  padding-right: 5px;
}

.seat-dropdown-toggle .selected-flight-info{
  display: flex;
  align-items: center;
}

.seat-dropdown-toggle:hover {
  cursor: pointer;
}
.seat-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  width: 100%;
  padding: 5px 0;
  margin: 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #FFFFFF;
  border: 1px solid #CDCECF;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0,0,0,.1);
}
.seat-dropdown-menu > li > a {
  color: var(--fontColor2);
  font-family: var(--fontFamily);
  padding: 0px 15px;
  margin: 0 0 5px;
  display: block;
  clear: both;
  font-weight: normal;
  white-space: nowrap;
  text-decoration: none;
  height: 30px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: flex-start;
}
.seat-dropdown-menu > li:last-of-type > a {
  margin-bottom: 0;
}
.seat-dropdown-menu > li > a:hover {
  color: var(--passengerSelectedColor);
}
.seat-dropdown-menu > li {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin: 0;
}
#ss-container li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Lib/Dropdown.vue